import { Injectable } from '@angular/core';
import { Person, PersonWithRelations } from '@rappider/rappider-sdk';

@Injectable({
  providedIn: 'root'
})
export class VerificationControlService {

  isVerificationRequired(person: Person | PersonWithRelations | any): boolean {
    if (person?.isVerified) {
      return false;
    }

    if (person?.verificationRequiredAfter) {
      const verificationRequiredDate = new Date(person.verificationRequiredAfter);
      const now = new Date();
      return now >= verificationRequiredDate;
    }

    if (person?.createdDate) {
      const createdDate = new Date(person.createdDate);
      const now = new Date();
      const hoursDiff = (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60);
      return hoursDiff >= 24;
    }

    return false;
  }

  canPerformActions(person: Person | PersonWithRelations | any): boolean {
    if (!person?.isVerified) {
      return false;
    }
    return !this.isVerificationRequired(person);
  }

  getVerificationMessage(person: Person | PersonWithRelations | any): string {
    if (person?.isVerified) {
      return null;
    }

    if (this.isVerificationRequired(person)) {
      return 'Please verify your email address or phone number to continue.';
    }

    if (!person?.isVerified) {
      return 'Please verify your email address or phone number to continue.';
    }

    return null;
  }

  getVerificationTooltip(person: Person | PersonWithRelations | any, customMessage?: string): string {
    const baseMessage = this.getVerificationMessage(person);
    if (baseMessage && customMessage) {
      return `${baseMessage} ${customMessage}`;
    }
    return baseMessage;
  }
}
